import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

const ContactInformationForm = ({
  contactInfo,
  setContactInfo,
  handleBack,
  handleNext,
  commonContainerStyle,
}) => {
  const [errors, setErrors] = useState({});

  const uiFieldStyles = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderRadius: "6px",
      "& fieldset": { borderColor: "#c9c9c9" },
      "&:hover fieldset": { borderColor: "#9d9d9d" },
      "&.Mui-focused fieldset": { borderColor: "#000" },
    },
    "& .MuiFormHelperText-root": { color: "#d32f2f" },
  };

  // ---------------- VALIDATION LOGIC ----------------
  const validateForm = () => {
    let newErrors = {};

    if (!contactInfo.city) newErrors.city = "Required";
    // if (!contactInfo.house_number) newErrors.house_number = "Required";
    // if (!contactInfo.street_name) newErrors.street_name = "Required";
    // if (!contactInfo.locality) newErrors.locality = "Required";
    // if (!contactInfo.state) newErrors.state = "Required";
    // if (!contactInfo.country) newErrors.country = "Required";

    // ZIP must be 5 or 6 digits
    // if (!contactInfo.zip_code) {
    //   newErrors.zip_code = "Required";
    // } else if (!/^\d{5,6}$/.test(contactInfo.zip_code)) {
    //   newErrors.zip_code = "Invalid ZIP";
    // }

    // Primary mobile = 10 digits
    if (!contactInfo.primary_mobile_number) {
      newErrors.primary_mobile_number = "Required";
    } else if (!/^\d{10}$/.test(contactInfo.primary_mobile_number)) {
      newErrors.primary_mobile_number = "Invalid number";
    }

    // Email validation
    // if (!contactInfo.email_address) {
    //   newErrors.email_address = "Required";
    // } else if (
    //   !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(contactInfo.email_address)
    // ) {
    //   newErrors.email_address = "Invalid email";
    // }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // ---------------- NEXT BUTTON HANDLER ----------------
  const handleNextClick = () => {
    if (!validateForm()) return; // ❌ Block going ahead
    handleNext(); // ✅ Form valid → go to next step
  };

  return (
    <Box
      sx={{
        ...commonContainerStyle,
        backgroundColor: "#d8f1f6",
        padding: { xs: 3, sm: 5 },
        borderRadius: "40px 40px 0 0",
        minHeight: "100vh",
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: "22px", sm: "24px", md: "28px" },
          fontWeight: 600,
          mb: 3,
        }}
      >
        Contact Information
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <Typography variant="subtitle1" sx={{ mb: 0, fontWeight: 600 }}>
            Residential Address*
          </Typography>
        </Grid>

        {/* House Number */}
        {/* <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            placeholder="Enter house number"
            sx={uiFieldStyles}
            value={contactInfo.house_number}
            onChange={(e) =>
              setContactInfo({
                ...contactInfo,
                house_number: e.target.value,
              })
            }
            error={Boolean(errors.house_number)}
            helperText={errors.house_number}
          />
        </Grid> */}

        {/* Street Name */}
        {/* <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            placeholder="Enter street name"
            sx={uiFieldStyles}
            value={contactInfo.street_name}
            onChange={(e) =>
              setContactInfo({
                ...contactInfo,
                street_name: e.target.value,
              })
            }
            error={Boolean(errors.street_name)}
            helperText={errors.street_name}
          />
        </Grid> */}

        {/* Locality */}
        {/* <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            placeholder="Enter locality"
            sx={uiFieldStyles}
            value={contactInfo.locality}
            onChange={(e) =>
              setContactInfo({
                ...contactInfo,
                locality: e.target.value,
              })
            }
            error={Boolean(errors.locality)}
            helperText={errors.locality}
          />
        </Grid> */}

        {/* City */}
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            City/Town/Village*
          </Typography>

          <TextField
            fullWidth
            placeholder="Enter city/town/village"
            sx={uiFieldStyles}
            value={contactInfo.city}
            onChange={(e) =>
              setContactInfo({ ...contactInfo, city: e.target.value })
            }
            error={Boolean(errors.city)}
            helperText={errors.city}
          />
        </Grid>

        {/* State */}
        {/* <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            State*
          </Typography>

          <FormControl
            fullWidth
            error={Boolean(errors.state)}
            sx={uiFieldStyles}
          >
            <Select
              value={contactInfo.state}
              displayEmpty
              onChange={(e) =>
                setContactInfo({
                  ...contactInfo,
                  state: e.target.value,
                })
              }
            >
              <MenuItem value="" disabled>
                Select state
              </MenuItem>
              <MenuItem value="Delhi">Delhi</MenuItem>
              <MenuItem value="Maharashtra">Maharashtra</MenuItem>
            </Select>

            <FormHelperText>{errors.state}</FormHelperText>
          </FormControl>
        </Grid> */}

        {/* Country */}
        {/* <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Country*
          </Typography>

          <TextField
            fullWidth
            placeholder="Enter country"
            sx={uiFieldStyles}
            value={contactInfo.country}
            onChange={(e) =>
              setContactInfo({ ...contactInfo, country: e.target.value })
            }
            error={Boolean(errors.country)}
            helperText={errors.country}
          />
        </Grid> */}

        {/* ZIP Code */}
        {/* <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            ZIP Code*
          </Typography>

          <TextField
            fullWidth
            placeholder="Enter ZIP code"
            sx={uiFieldStyles}
            value={contactInfo.zip_code}
            onChange={(e) =>
              setContactInfo({
                ...contactInfo,
                zip_code: e.target.value,
              })
            }
            error={Boolean(errors.zip_code)}
            helperText={errors.zip_code}
          />
        </Grid> */}

        {/* Primary Mobile */}
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Primary Mobile Number*
          </Typography>

          <TextField
            fullWidth
            type="tel"
            placeholder="Enter primary mobile"
            sx={uiFieldStyles}
            value={contactInfo.primary_mobile_number}
            onChange={(e) =>
              setContactInfo({
                ...contactInfo,
                primary_mobile_number: e.target.value,
              })
            }
            error={Boolean(errors.primary_mobile_number)}
            helperText={errors.primary_mobile_number}
          />
        </Grid>

        {/* Alternate Mobile */}
        {/* <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Alternate Mobile Number
          </Typography>

          <TextField
            fullWidth
            type="tel"
            placeholder="Enter alternate mobile"
            sx={uiFieldStyles}
            value={contactInfo.secondary_mobile_number}
            onChange={(e) =>
              setContactInfo({
                ...contactInfo,
                secondary_mobile_number: e.target.value,
              })
            }
          />
        </Grid> */}

        {/* Email */}
        {/* <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Email Address*
          </Typography>

          <TextField
            fullWidth
            type="email"
            placeholder="Enter email address"
            sx={uiFieldStyles}
            value={contactInfo.email_address}
            onChange={(e) =>
              setContactInfo({
                ...contactInfo,
                email_address: e.target.value,
              })
            }
            error={Boolean(errors.email_address)}
            helperText={errors.email_address}
          />
        </Grid> */}

        {/* Footer Buttons */}
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mt={5}
        >
          <Button
            variant="outlined"
            onClick={handleBack}
            sx={{
              color: "black",
              borderColor: "black",
              "&:hover": { backgroundColor: "#f0f0f0", borderColor: "#333" },
            }}
          >
            Go Back
          </Button>

          <Box display="flex" alignItems="center" gap={2}>
            <Typography sx={{ fontSize: "12px" }}>*imp fields</Typography>

            <Button
              variant="contained"
              onClick={(e) => handleNext(e)}
              sx={{
                backgroundColor: "#2C2C2C",
                color: "white",
                padding: "6px 28px",
                borderRadius: "6px",
                "&:hover": { backgroundColor: "#444" },
              }}
            >
              Next
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContactInformationForm;
